import * as React from 'react';

function SvgVideoDownload(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.887 10.657a.142.142 0 00.225 0l2-2.53a.143.143 0 00-.112-.23H8.677V1.854a.143.143 0 00-.143-.143H7.462a.143.143 0 00-.143.143v6.04H6a.142.142 0 00-.112.231l2 2.532zm6.649-.625h-1.072a.143.143 0 00-.143.143v2.75H2.678v-2.75a.143.143 0 00-.142-.143H1.464a.143.143 0 00-.143.143v3.536a.57.57 0 00.572.571h12.214a.57.57 0 00.571-.571v-3.536a.143.143 0 00-.142-.143z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgVideoDownload;
